import React, { useContext, useEffect, useMemo, useState } from 'react'
import { AuthContext, ThemeContext } from '../../../../auth';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { axiosAuth } from '../../../../api';

function ModalUbahPcpDetail({
    rowSelected,
    showEditPcpDetail,
    setShowEditPcpDetail,
    listCategory,
    formStyles,
    selectStyles,
    pcpData,
    retrievePCPDetail
}) {

    const { userInfo, accessToken, company } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleClose = () => {
        setShowEditPcpDetail(false);
    };

    const formatToIDR = (value) => {
        const numericValue = parseFloat(value.replace(/[^\d]/g, '')) || 0;
        return `Rp ${numericValue.toLocaleString('id-ID')}`;
    };

    const parseInitialPrice = (value) => {
        return value ? parseFloat(value).toFixed(0) : "";
    };

    const defaultValue = {
        productName: rowSelected?.productName || "",
        categoryId: rowSelected?.category?.id || "",
        duration: rowSelected?.duration || "",
        buyingPrice: rowSelected?.buyingPrice ? parseInitialPrice(rowSelected.buyingPrice) : 0,
        sellingPrice: rowSelected?.sellingPrice ? parseInitialPrice(rowSelected.sellingPrice) : "",
        quantity: rowSelected?.quantity || "",
        productDesc: rowSelected?.productDesc || "",
    };

    const handleBuyingPriceChange = (e, setFieldValue) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/[^\d]/g, '');
        setFieldValue('buyingPrice', numericValue);
    };

    const handleSellingPriceChange = (e, setFieldValue) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/[^\d]/g, '');
        setFieldValue('sellingPrice', numericValue);
    };

    const categoryOptions = useMemo(() => {
        return listCategory.map(category => ({
            value: category.id,
            label: category.categoryName,
        }));
    }, [listCategory]);

    const handleSelectCategory = (selectedOption, setFieldValue) => {
        setFieldValue('categoryId', selectedOption ? selectedOption.value : null);
    };

    console.log(listCategory)

    useEffect(() => {
        if (showEditPcpDetail && rowSelected) {
            setSelectedCategory(
                categoryOptions.find(option => option.value === rowSelected?.categoryId) || null
            );
        }
    }, [showEditPcpDetail, rowSelected, categoryOptions]);

    const handleSubmitEditPCP = async (values) => {

        setIsSubmitting(true);
        setDisabled(true);

        const marginTotal = ((parseFloat(values.sellingPrice) - parseFloat(values.buyingPrice)) / parseFloat(values.sellingPrice)) * 100;

        const dataPCPDetail = {
            username: userInfo?.username,
            subtotal: values.sellingPrice * values.quantity,
            margin: marginTotal.toFixed(2) || 0,
            ...values
        }

        try {

            const response = await axiosAuth.put(`/api/pcp/details/${rowSelected?.id}`, dataPCPDetail, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleClose();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengupdate Produk',
                showConfirmButton: true,
            });

            retrievePCPDetail();

            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {
            console.error(err);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengupdate Produk',
            });

            setIsSubmitting(false);
            setDisabled(false);

        } finally {

            setIsSubmitting(false);
            setDisabled(false);

        }
    };


    return (
        <Modal
            show={showEditPcpDetail}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size='md'
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222', }}>
                    Ubah Produk
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize={true}
                    onSubmit={(values) => {
                        const formValues = {
                            ...values,
                            buyingPrice: parseFloat(values.buyingPrice).toFixed(2),
                            sellingPrice: parseFloat(values.sellingPrice).toFixed(2),
                        };
                        handleSubmitEditPCP(formValues);
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        setFieldValue,
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='productName'>Nama Produk*</Form.Label>
                                <Form.Control
                                    id='productName'
                                    type='text'
                                    value={values.productName}
                                    onChange={handleChange("productName")}
                                    required
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='category'>Jenis Produk*</Form.Label>
                                <Select
                                    id='category'
                                    options={categoryOptions}
                                    required
                                    value={categoryOptions.find(option => option.value === values.categoryId) || null}
                                    onChange={(selectedOption) => handleSelectCategory(selectedOption, setFieldValue)}
                                    styles={selectStyles}
                                    placeholder='Pilih Jenis Produk'
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='spec'>Spesifikasi</Form.Label>
                                <Form.Control
                                    id='spec'
                                    as='textarea'
                                    rows={4}
                                    value={values.productDesc}
                                    onChange={handleChange("productDesc")}
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='buyingPrice'>Harga Beli*</Form.Label>
                                <Form.Control
                                    id='buyingPrice'
                                    type='text'
                                    value={values.buyingPrice ? formatToIDR(values.buyingPrice) : ""}
                                    onChange={(e) => handleBuyingPriceChange(e, setFieldValue)}
                                    required
                                    placeholder='Harga Beli'
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='sellingPrice'>Harga Jual*</Form.Label>
                                <Form.Control
                                    id='sellingPrice'
                                    type='text'
                                    value={values.sellingPrice ? formatToIDR(values.sellingPrice) : ""}
                                    onChange={(e) => handleSellingPriceChange(e, setFieldValue)}
                                    required
                                    placeholder='Harga Jual'
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='quantity'>Qty*</Form.Label>
                                <Form.Control
                                    id='quantity'
                                    type='number'
                                    value={values.quantity}
                                    onChange={handleChange("quantity")}
                                    required
                                    style={formStyles.input}
                                    placeholder='Jumlah'
                                />
                            </Form.Group>
                            <div className="d-grid gap-2 mt-4 mb-2">
                                {isSubmitting ? (
                                    <Button
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled
                                    >
                                        <Spinner
                                            animation="border"
                                            size='sm'
                                        />
                                    </Button>
                                ) : (
                                    <Button
                                        type="submit"
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled={disabled}
                                    >
                                        Simpan
                                    </Button>
                                )}
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default ModalUbahPcpDetail
